import { Ref, useStore, computed, useContext, ref } from '@nuxtjs/composition-api';
import { User } from '~/types/user';
import { Resource } from '~/types/resource';
import { State } from '~/store';

interface UseDownload {
  isDownloading: Ref<boolean>;
  download: (fromModal?: boolean) => Promise<void>;
}

export const useDownload = (item?: Resource): UseDownload => {
  const store = useStore<State>();
  const loggedInUser = computed<User>(() => store.getters.loggedInUser);
  const {
    $config,
    i18n,
    route,
    $constructHomeFeedDownloadEvent,
    $constructIntercomHomeFeedDownloadEvent,
    $intercom,
    $sendAlgoliaConversion,
    $quickDownload,
    $mzAnalyticsApi,
  } = useContext();
  const { baseURL } = $config;

  const isDownloading = ref<boolean>(false);

  const eventInstantFileDownloaded = (): void => {
    if (!item) {
      return;
    }
    const params = $constructHomeFeedDownloadEvent(item);
    const eventAction =
      params.File_Format === 'slide' || params.File_Format === 'sheet' ? 'Opened' : 'Downloaded'; // Exception for Google Slides or Sheets
    // @ts-ignore
  };

  const eventInstantFileDownloadedIntercom = (): void => {
    if (!item) {
      return;
    }
    const params = $constructIntercomHomeFeedDownloadEvent(item);
    const resourceType = item.is_free ? 'Free' : ' Premium';
    if (process.client && typeof window.gtag !== 'undefined') {
      window.gtag('event', 'resourceInteraction', {
        userUuid: loggedInUser.value.uuid,
        eventAction: 'Resource Interaction',
        resourceType,
        resourceName: item.name,
        resourceId: item.file_id,
        resourceLink: item.link,
      });
    }
    if (typeof $intercom !== 'undefined') {
      $intercom.trackEvent('Resource Downloaded', params);
    }
  };

  const download = async (fromModal?: boolean): Promise<void> => {
    if (!item || !item.file_id) {
      return;
    }
    isDownloading.value = true;
    if (!item.file_id) {
      console.error('No file_id found for resource', item);
      return;
    }
    await $quickDownload(item.file_id);
    isDownloading.value = false;
    $mzAnalyticsApi({
      event: 'click',
      name: 'resource_card.download',
      entityType: item.type,
      entityId: item.id,
    });
    eventInstantFileDownloaded();
    eventInstantFileDownloadedIntercom();
    $sendAlgoliaConversion(String(item.old_id));
  };

  return {
    isDownloading,
    download,
  };
};
